import React from "react";
import { cx } from "./utils";

const tones = {
  blue: "border-blue-200 bg-blue-50 text-blue-700",
  emerald: "border-emerald-200 bg-emerald-50 text-emerald-700",
  amber: "border-amber-200 bg-amber-50 text-amber-700",
  rose: "border-rose-200 bg-rose-50 text-rose-700",
  orange: "border-orange-200 bg-orange-50 text-orange-700",
  violet: "border-violet-200 bg-violet-50 text-violet-700",
  slate: "border-slate-200 bg-slate-50 text-slate-700",
};

const sizes = {
  md: "rounded-xl px-3 py-2 text-sm",
  sm: "rounded-full px-2.5 py-1 text-xs",
};

const StatusBadge = ({ children, tone = "slate", size = "md", className = "", title }) => (
  <span
    title={title}
    className={cx(
      "inline-flex items-center gap-2 border font-medium shadow-sm",
      tones[tone] || tones.slate,
      sizes[size] || sizes.md,
      className
    )}
  >
    {children}
  </span>
);

export default StatusBadge;
